// Route helpers for the species / kingdom pages (see Client/TaxonomyPage.js).
//
// Both routes carry a free-text taxonomy label as a single path segment:
// `/species/Abies grandis`, `/kingdom/Plantae (Angiosperm)`. The labels come
// straight from `enzyme.species` / `enzyme.kingdom` (both TEXT), so they hold
// spaces, dots, parentheses and the odd "sp."/"subsp." — everything has to go
// through encodeURIComponent, and react-router's useParams decodes it back.
// Keep every link to those pages going through these two helpers so the
// encoding stays in one place.
//
// Both routes are a single `:value` segment, so a label containing a literal
// "/" would not round-trip. No `enzyme.species` or `enzyme.kingdom` in MARTS
// contains one (checked against release 2026-08: no "/", "?", "#", backslash,
// quote or non-ASCII character in any label), but a future one would need a
// splat route (`/species/*`) here.

function speciesLink(species) {
  return `/species/${encodeURIComponent(species)}`;
}

function kingdomLink(kingdom) {
  return `/kingdom/${encodeURIComponent(kingdom)}`;
}

export { speciesLink, kingdomLink };
